module.exports = __webpack_public_path__ + "static/media/circumference_cat_french.26b8a7d9.png";